// Typelizer digest 540011fb44025ee6a6701fb06886c367
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/counterparties */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/counterparties', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/ledger/counterparties/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/counterparties/:id', params, options),
    method: 'get',
  }),
}
